import ApiConnector from '@/models/ApiConnector';
import ApiModel     from '@widesk-core/models/ApiModel';
import config  from '@/config';

export const shopConnector = new ApiConnector({
	baseURL: config.api_endpoint + `/shop`,
});

export default class ShopServiceModel extends ApiModel {
	public static get connector() {
		return shopConnector;
	}

	public static serviceName = 'shop';
	public static partitionName = 'jts';
}